import { lazy, Suspense } from 'react';

import { ErrorBoundary } from '~/core/shared/components';
import { ENVIRONMENT } from './core/shared/constants';

const tenants: Record<string, ReturnType<typeof lazy>> = {
  'rapid-loans': lazy(() => import('./tenants/rapid-loans')),
  resimac: lazy(() => import('./tenants/resimac')),
};

const { tenant } = ENVIRONMENT;
const TenantApp = tenants[tenant];

if (!TenantApp) {
  throw new Error(
    `[root] Unsupported tenant "${tenant}". Available tenants: ${Object.keys(tenants).join(', ')}`,
  );
}

export default function Root() {
  return (
    <ErrorBoundary>
      <Suspense fallback={null}>
        <TenantApp />
      </Suspense>
    </ErrorBoundary>
  );
}
